import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const AcceptProfile = ({ scheme }) => {
  const { search } = useLocation();
  const suit = search.replace("?SUIT=", "");

  useEffect(() => {
    if (typeof window !== "undefined") {
      console.log(`${scheme}AcceptProfile/${suit}`);
      window.location.href = `${scheme}AcceptProfile/${suit}`;
    }
  }, [scheme]);
  return <></>;
};
